<template>
    
    <div class="container">
        <div class="row col-md-9 mx-auto my-5">
            <h2 class="mt-5" style="font-weight: bold;">گزارشات ناباکو</h2>
            <div class="row my-5">
                <h4><strong>گزارش اسفند ماه</strong> <strong style="color: green;">%11+</strong></h4>
                <div class="row bg-light py-2">
                    <div class="col-md-3">
                        <strong>CRYPTO</strong>
                    </div>
                    <div class="col-md-3">
                        تعداد کل : 374
                    </div>
                    <div class="col-md-3">
                        TP : 364
                    </div>
                    <div class="col-md-3">
                        SL : 10    
                    </div>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Symbole</th>
                      <th scope="col">Profit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>BTCUSDT</th>
                      <td>6.61%+</td>
                    </tr>
                    <tr>
                      <th>RUNEUSDT</th>
                      <td>4.39%+</td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div class="row my-5">
                <h4><strong>گزارش اسفند ماه</strong> <strong style="color: green;">970PIP+</strong></h4>
                <div class="row bg-light py-2">
                    <div class="col-md-3">
                        <strong>FOREX</strong>
                    </div>
                    <div class="col-md-3">
                        تعداد کل : 35
                    </div>
                    <div class="col-md-3">
                        TP : 35
                    </div>
                    <div class="col-md-3">
                        SL : 0    
                    </div>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Symbole</th>
                      <th scope="col">Profit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>XAUUSD</th>
                      <td>970IP+</td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div class="row my-5">
                <h4><strong>گزارش بهمن ماه</strong> <strong style="color: green;">%11+</strong></h4>
                <div class="row bg-light py-2">
                    <div class="col-md-3">
                        <strong>CRYPTO</strong>
                    </div>
                    <div class="col-md-3">
                        تعداد کل : 365
                    </div>
                    <div class="col-md-3">
                        TP : 352
                    </div>
                    <div class="col-md-3">
                        SL : 13    
                    </div>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Symbole</th>
                      <th scope="col">Profit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>BTCUSDT</th>
                      <td>6.61%+</td>
                    </tr>
                    <tr>
                      <th>RUNEUSDT</th>
                      <td>4.39%+</td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div class="row my-5">
                <h4><strong>گزارش بهمن ماه</strong> <strong style="color: green;">496PIP+</strong></h4>
                <div class="row bg-light py-2">
                    <div class="col-md-3">
                        <strong>FOREX</strong>
                    </div>
                    <div class="col-md-3">
                        تعداد کل : 45
                    </div>
                    <div class="col-md-3">
                        TP : 41
                    </div>
                    <div class="col-md-3">
                        SL : 4    
                    </div>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Symbole</th>
                      <th scope="col">Profit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>EURUSD</th>
                      <td>67PIP+</td>
                    </tr>
                    <tr>
                      <th>USDCAD</th>
                      <td>46PIP+</td>
                    </tr>
                    <tr>
                      <th>AUDCHF</th>
                      <td>80PIP+</td>
                    </tr>
                    <tr>
                      <th>AUDUSD</th>
                      <td>-25PIP</td>
                    </tr>
                    <tr>
                      <th>USDJPY</th>
                      <td>32PIP+</td>
                    </tr>
                    <tr>
                      <th>GBPJPY</th>
                      <td>130PIP+</td>
                    </tr>
                    <tr>
                      <th>XAUUSD</th>
                      <td>-97PIP</td>
                    </tr>
                    <tr>
                      <th>EURGBP</th>
                      <td>62PIP+</td>
                    </tr>
                    <tr>
                      <th>EURJPY</th>
                      <td>151PIP+</td>
                    </tr>
                    <tr>
                      <th>NZDUSD</th>
                      <td>10PIP+</td>
                    </tr>
                    <tr>
                      <th>GBPUSD</th>
                      <td>120PIP+</td>
                    </tr>
                    <tr>
                      <th>EURCAD</th>
                      <td>35PIP+</td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div class="row my-5">
                <h4><strong>گزارش دی ماه</strong> <strong style="color: green;">%25.5+</strong></h4>
                <div class="row bg-light py-2">
                    <div class="col-md-3">
                        <strong>CRYPTO</strong>
                    </div>
                    <div class="col-md-3">
                        تعداد کل : 494
                    </div>
                    <div class="col-md-3">
                        TP : 484
                    </div>
                    <div class="col-md-3">
                        SL : 10    
                    </div>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Symbole</th>
                      <th scope="col">Profit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>BTCUSDT</th>
                      <td>16.71%+</td>
                    </tr>
                    <tr>
                      <th>RUNEUSDT</th>
                      <td>8.79%+</td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div class="row my-5">
                <h4><strong>گزارش دی ماه</strong> <strong style="color: green;">625PIP+</strong></h4>
                <div class="row bg-light py-2">
                    <div class="col-md-3">
                        <strong>FOREX</strong>
                    </div>
                    <div class="col-md-3">
                        تعداد کل : 39
                    </div>
                    <div class="col-md-3">
                        TP : 39
                    </div>
                    <div class="col-md-3">
                        SL : 0    
                    </div>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Symbole</th>
                      <th scope="col">Profit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>EURUSD</th>
                      <td>37PIP+</td>
                    </tr>
                    <tr>
                      <th>USDCAD</th>
                      <td>12PIP+</td>
                    </tr>
                    <tr>
                      <th>AUDCHF</th>
                      <td>46PIP+</td>
                    </tr>
                    <tr>
                      <th>AUDUSD</th>
                      <td>55PIP+</td>
                    </tr>
                    <tr>
                      <th>USDJPY</th>
                      <td>89PIP+</td>
                    </tr>
                    <tr>
                      <th>GBPJPY</th>
                      <td>144PIP+</td>
                    </tr>
                    <tr>
                      <th>AUDUSD</th>
                      <td>8PIP+</td>
                    </tr>
                    <tr>
                      <th>EURGBP</th>
                      <td>6PIP+</td>
                    </tr>
                    <tr>
                      <th>EURJPY</th>
                      <td>69PIP+</td>
                    </tr>
                    <tr>
                      <th>NZDUSD</th>
                      <td>22PIP+</td>
                    </tr>
                    <tr>
                      <th>USDCHF</th>
                      <td>86PIP+</td>
                    </tr>
                    <tr>
                      <th>GBPUSD</th>
                      <td>6PIP+</td>
                    </tr>
                    <tr>
                      <th>USDCAD</th>
                      <td>45PIP+</td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div class="row my-5">
                <h4><strong>گزارش آذر ماه</strong> <strong style="color: green;">%4+</strong></h4>
                <div class="row bg-light py-2">
                    <div class="col-md-3">
                        <strong>CRYPTO</strong>
                    </div>
                    <div class="col-md-3">
                        تعداد کل : 57
                    </div>
                    <div class="col-md-3">
                        TP : 48
                    </div>
                    <div class="col-md-3">
                        SL : 9    
                    </div>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Symbole</th>
                      <th scope="col">Profit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>BTCUSDT</th>
                      <td>1.02%+</td>
                    </tr>
                    <tr>
                      <th>RUNEUSDT</th>
                      <td>0.19%+</td>
                    </tr>
                    <tr>
                      <th>ETHUSDT</th>
                      <td>0.14%+</td>
                    </tr>
                    <tr>
                      <th>XRPUSDT</th>
                      <td>0.17%+</td>
                    </tr>
                    <tr>
                      <th>GRTUSDT</th>
                      <td>0.38%+</td>
                    </tr>
                    <tr>
                      <th>ETHUSDT</th>
                      <td>0.14%+</td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div class="row my-5">
                <h4><strong>گزارش آذر ماه</strong> <strong style="color: green;">277PIP+</strong></h4>
                <div class="row bg-light py-2">
                    <div class="col-md-3">
                        <strong>FOREX</strong>
                    </div>
                    <div class="col-md-3">
                        تعداد کل : 60
                    </div>
                    <div class="col-md-3">
                        TP : 50
                    </div>
                    <div class="col-md-3">
                        SL : 10    
                    </div>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Symbole</th>
                      <th scope="col">Profit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>XAUUSD</th>
                      <td>80PIP+</td>
                    </tr>
                    <tr>
                      <th>AUDUSD</th>
                      <td>40PIP+</td>
                    </tr>
                    <tr>
                      <th>GBPUSD</th>
                      <td>60PIP+</td>
                    </tr>
                    <tr>
                      <th>GBPJPY</th>
                      <td>23PIP+</td>
                    </tr>
                    <tr>
                      <th>AUDCHF</th>
                      <td>14PIP+</td>
                    </tr>
                    <tr>
                      <th>EURUSD</th>
                      <td>60PIP+</td>
                    </tr>
                  </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>